import { AppInterface } from "@swivl-mono/types";
import { Input, Spinner } from "@swivl-mono/ui";
import React from "react";

import { ConversationRestrictionsControls } from "../../../../Components/ConversationRestrictionsControls/ConversationRestrictionsControls";
import { VoiceSpeechModelSelector } from "../../../../Components/VoiceSpeechModelSelector/VoiceSpeechModelSelector";
import AppsModel from "../../../../Models/Apps/Apps.Model";
import { NavBar } from "../../../../Models/NavBar/NavBar.Model";
import { QuestsDropdown } from "../../../../Components/Dropdowns/QuestsDropdown/QuestsDropdown";

interface Props {
  app: AppInterface;
  selected?: boolean;
}
export default class TwilioView extends React.Component<Props> {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
    this.onBlur = this.onBlur.bind(this);
  }

  componentWillMount() {
    NavBar.set(<NavBar.Component.Back />, <NavBar.Component.Title> Twilio App Settings</NavBar.Component.Title>, null);
  }
  onChange(e) {
    const app = { ...this.props.app };
    const name = e.target.name;
    const value = e.target.value;
    if (name === "phoneNumber") {
      app.identifier = value;
    } else {
      let token = app.token || {};
      token[name] = value;
      app.token = token;
    }

    AppsModel.update(app, false);
  }
  onBlur(e) {
    AppsModel.update(this.props.app, true);
  }

  render() {
    const { app } = this.props;
    var content;

    if (!app) {
      content = <Spinner />;
    } else {
      const token = app.token || {};
      const phoneNumber = app.identifier || "";
      const startOnQuest = app.data?.startOnQuest || "";

      content = (
        <div className="twilioValues">
          <label>Phone Number (ie. +17205551234)</label>
          <Input name="phoneNumber" value={phoneNumber} onChange={this.onChange} onBlur={this.onBlur} />
          <label>SID</label>
          <Input name="accountSid" value={token.accountSid} onChange={this.onChange} onBlur={this.onBlur} />
          <label>Auth Token</label>
          <Input type={Input.Type.Password} name="authToken" value={token.authToken} onChange={this.onChange} onBlur={this.onBlur} />

          {/* <label>API Key</label>
          <Input name="apiKey" value={token.apiKey} onChange={this.onChange} onBlur={this.onBlur} />
          <label>API Secret</label>
          <Input type={Input.Type.Password} name="apiSecret" value={token.apiSecret} onChange={this.onChange} onBlur={this.onBlur} /> */}

          {/* <label>Instalation Instructions</label> */}
          {/* <div className="instructions">
                  To complete the instalation, you must set the SMS webhook for your  account to:<br/>
                  <SSCopyToClipboard
                    copyValue={"https://api.swivl.studio/apps/twilio"}
                    copiedComponent={
                      <div className="webhook">https://api.swivl.studio/apps/twilio <span>COPIED</span></div>
                    }
                    >
                    <div className="webhook">https://api.swivl.studio/apps/twilio <span>COPY</span></div>
                    </SSCopyToClipboard>

                  </div> */}

          <hr className="mb-5 mt-5" />
          {/* <VoiceSpeechModelSelector
            voiceSpeechModel={app.data?.voiceSpeechModel || {}}
            updateVoiceSpeechModel={(data) => {
              const app = { ...this.props.app };
              app.data.voiceSpeechModel = data;
              AppsModel.update(app, true);
            }}
          /> */}
          <label>
            Voice Speech Model &nbsp;
            <a
              href="https://www.twilio.com/docs/voice/conversationrelay/voice-configuration"
              target="_blank"
              rel="noopener noreferrer"
              style={{ fontWeight: 400, fontSize: "0.95em" }}
            >
              (Click to see available models. Copy VoiceID and paste below)
            </a>
          </label>
          <Input name="voiceSpeechModel" value={app.data?.voiceSpeechModel} onChange={(e) => {
            const app = { ...this.props.app };
            app.data.voiceSpeechModel = e.target.value;
            AppsModel.update(app, true);
          }} onBlur={this.onBlur} placeholder="wvk9Caj0nEx4l3I9LaR6" />
          <label>Start on Quest</label>
          <QuestsDropdown value={startOnQuest} name="startOnQuest" onChange={(data) => {
            if (!data.target.value) {
              return;
            }
            const app = { ...this.props.app };
            app.data.startOnQuest = data.target.value;
            console.log("app :", app);
            AppsModel.update(app, true);
          }} />
          <ConversationRestrictionsControls
            restrictionsData={app.data?.locationRestrictions || {}}
            updateRestrictionsData={(data) => {
              const app = { ...this.props.app };
              app.data.locationRestrictions = data;
              AppsModel.update(app, true);
            }}
          />
        </div>
      );
    }

    return (
      <div className="TwilioView">
        <img src="https://swivl-cdn.s3-us-west-1.amazonaws.com/twilio-logo-red.png" width={389} height={179} />

        {content}
      </div>
    );
  }
}
